/* PP product page refresh: enhances Dawn's main-product markup on every product template. */
(function () {
  var dataEl = document.getElementById('pp-pdp-data');
  var root = document.querySelector('.product__info-container');
  if (!dataEl || !root) return;
  var cfg = {};
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) {}
  var vendor = (cfg.vendor || '').trim().toLowerCase();

  function enhance() {
    // Vendor caption adds nothing above the title
    if (vendor) {
      root.querySelectorAll('.product__text').forEach(function (p) {
        if (p.textContent.trim().toLowerCase() === vendor) p.classList.add('pp-hide');
      });
    }

    // Option cards: "Switch: Gateron Brown" legend
    root.querySelectorAll('.product-form__input--pill').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var checked = fs.querySelector('input[type=radio]:checked');
      if (legend) {
        var sel = legend.querySelector('.pp-sel');
        if (!sel) { sel = document.createElement('span'); sel.className = 'pp-sel'; legend.appendChild(sel); }
        var v = checked ? checked.value : '';
        if (sel.textContent !== v) sel.textContent = v;
        sel.hidden = !v;
      }
    });

    // Quantity stepper beside Add to cart
    var buttons = root.querySelector('product-form .product-form__buttons');
    var qty = root.querySelector('.product-form__quantity');
    if (buttons) {
      buttons.classList.add('pp-buyrow');
      if (qty && !buttons.contains(qty)) buttons.insertBefore(qty, buttons.firstChild);
    }

    // Ship-today line + trust tiles under the buy block
    var form = root.querySelector('product-form');
    var tpl = document.getElementById('pp-pdp-after');
    if (form && tpl && !root.querySelector('.pp-after')) {
      var block = form.parentElement === root ? form : form.parentElement;
      block.parentNode.insertBefore(tpl.content.cloneNode(true), block.nextSibling);
    }

    // Description: heading + Read more
    var desc = root.querySelector('.product__description');
    if (desc && !desc.hasAttribute('data-pp')) {
      desc.setAttribute('data-pp', '');
      var h = document.createElement('h2');
      h.className = 'pp-desc-h h4';
      h.textContent = 'Description';
      desc.parentNode.insertBefore(h, desc);
      if (desc.scrollHeight > 220) {
        desc.classList.add('pp-clamp');
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'pp-more';
        more.textContent = 'Read more';
        more.setAttribute('aria-expanded', 'false');
        more.addEventListener('click', function () {
          var open = desc.classList.toggle('pp-clamp') === false;
          more.textContent = open ? 'Show less' : 'Read more';
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        desc.parentNode.insertBefore(more, desc.nextSibling);
      }
    }
  }

  // Mobile sticky buy bar
  var bar = document.getElementById('pp-sticky');
  var barOn = false;
  function syncBar() {
    if (!bar) return;
    var v = null;
    var vs = root.querySelector('variant-selects [data-selected-variant]');
    if (vs) { try { v = JSON.parse(vs.textContent); } catch (e) {} }
    bar.querySelector('.pp-sticky__var').textContent = v && v.public_title ? v.public_title : '';
    var img = bar.querySelector('.pp-sticky__img');
    if (img && v && v.featured_image && v.featured_image.src) img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    var pr = root.querySelector('.price--large');
    var sale = pr && pr.classList.contains('price--on-sale');
    var p = pr && pr.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
    bar.querySelector('.pp-sticky__amt').textContent = p ? p.textContent.trim() : '';
    var b = pr && pr.querySelector('.price__badge-sale');
    var badge = bar.querySelector('.pp-sticky__badge');
    var bt = b ? b.textContent.trim() : '';
    badge.hidden = !(sale && /%/.test(bt));
    badge.textContent = bt.replace(/^save\s*/i, '-');
    var main = root.querySelector('.product-form__submit');
    var btn = bar.querySelector('.pp-sticky__btn');
    if (main) {
      btn.disabled = main.disabled;
      var t = main.querySelector('span');
      btn.textContent = t && t.textContent.trim() ? t.textContent.trim() : 'Add to cart';
    }
  }
  function initBar() {
    var main = root.querySelector('.product-form__submit');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    // Rendered inside the header section, whose sticky transform would carry a fixed child with it
    document.body.appendChild(bar);
    var btn = bar.querySelector('.pp-sticky__btn');
    btn.tabIndex = -1;
    btn.addEventListener('click', function () {
      var m = root.querySelector('.product-form__submit');
      if (m && !m.disabled) m.click();
    });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      barOn = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (barOn) syncBar();
      bar.classList.toggle('is-on', barOn);
      bar.setAttribute('aria-hidden', barOn ? 'false' : 'true');
      btn.tabIndex = barOn ? 0 : -1;
      document.body.classList.toggle('pp-sticky-on', barOn);
    }).observe(main);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      enhance();
      if (barOn) syncBar();
    });
  }

  function start() {
    enhance();
    initBar();
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
